import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const notificationSettingsApi = createApi({
  reducerPath: 'notificationSettingsApi',
  baseQuery: createBaseQuery('notification_settings', { timeout: 0 }),
  endpoints: builder => ({
    getNotificationSetting: builder.query({
      query: () => `/`,
    }),
    updateNotificationSetting: builder.mutation({
      query: params => ({
        url: '/',
        method: 'PUT',
        body: params,
      }),
    }),
  }),
});

export const { useGetNotificationSettingQuery, useUpdateNotificationSettingMutation } =
  notificationSettingsApi;
